const header = {
  'No tienes notificaciones nuevas': 'No tenés notificaciones nuevas.',
  'Ingresa a tu cuenta y encuentra el trabajo que buscas': 'Ingresá a tu cuenta y encontrá el trabajo que buscás.',
}

export default header
